/* unplugin-vue-components disabled */import { render } from "./xinjiangMap.vue?vue&type=template&id=45103666&scoped=true"
import script from "./xinjiangMap.vue?vue&type=script&lang=js"
export * from "./xinjiangMap.vue?vue&type=script&lang=js"

import "./xinjiangMap.vue?vue&type=style&index=0&id=45103666&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45103666"]])

export default __exports__